import React, {Component} from 'react';
import styled from 'styled-components';

class Main extends Component {
    render() {
        return (
            <main className={this.props.className}>
                {this.props.children}
            </main>
        );
    }
}

export default styled(Main)`
    flex-grow: 1;
`;